/**
 * @description: 充公明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="war-cgm-report">
        <div class="cm-list">
            <el-form :inline="true" size="small" :model="cm_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="cm_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="cm_list_form.start_date"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="cm_list_form.end_date"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="cm_list_form.shop_id" filterable clearable placeholder="请选择门店" @change="getStore">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="仓库">
                    <el-select v-model="cm_list_form.store_id" filterable clearable placeholder="请选择仓库" :disabled="cm_list_form.store_disabled">
                        <el-option v-for="item in store_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-select v-model="cm_list_form.goods_type" filterable clearable placeholder="请选择商品类型">
                        <el-option v-for="item in goods_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="库存变化">
                    <el-select v-model="cm_list_form.status" filterable clearable placeholder="请选择库存变化">
                        <el-option label="入库" value="1"></el-option>
                        <el-option label="出库" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="cm_list_form.mobile" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="操作类型">
                    <el-select v-model="cm_list_form.relation_type" filterable clearable placeholder="请选择操作类型">
                        <el-option label="手动充公" value="1"></el-option>
                        <el-option label="自动充公" value="2"></el-option>
                        <el-option label="取消充公" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="cmQuery">查询</el-button>
                    <el-button @click="cmExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="cm_list">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column prop="time" width="100" label="充公时间"></el-table-column>
                <el-table-column prop="relation_id" width="110" label="寄存单号"></el-table-column>
                <el-table-column width="130" label="门店">
                    <template slot-scope="scope">
                        {{scope.row.shop_name.length > '14' ? scope.row.shop_name.slice(0, 14) + '...' : scope.row.shop_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column width="130" label="商品名称">
                    <template slot-scope="scope">
                        {{scope.row.goods_name.length > '14' ? scope.row.goods_name.slice(0, 14) + '...' : scope.row.goods_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="quantity" label="充公数量"></el-table-column>
                <el-table-column prop="relation_type_name" label="操作类型"></el-table-column>
                <el-table-column prop="store_name" label="仓库"></el-table-column>
                <el-table-column prop="status" label="库存变化"></el-table-column>
                <el-table-column prop="buying_price" label="进货单价"></el-table-column>
                <el-table-column prop="buying_price_total" label="进货价合计"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-4">充公总量:</label>
                    <div class="list-total">{{cm_quantity_total}}</div>
                    <label class="list-label-4">进货总价:</label>
                    <div class="list-total">{{cm_buying_price_total}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="cm_list_page"
                    :total="cm_list_total"
                    @current-change="getCmList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="cm_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="cm_export_sign" v-model="cm_export_all" @change="cmExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="cm_export_ids" @change="cmExportChange">
                    <el-checkbox label="time">充公时间</el-checkbox>
                    <el-checkbox label="relation_id">寄存单号</el-checkbox>
                    <el-checkbox label="shop_name">门店</el-checkbox>
                    <el-checkbox label="mobile">手机号</el-checkbox>
                    <el-checkbox label="goods_type_name">商品类型</el-checkbox>
                    <el-checkbox label="goods_name">商品名称</el-checkbox>
                    <el-checkbox label="goods_unit_name">单位</el-checkbox>
                    <el-checkbox label="quantity">充公数量</el-checkbox>
                    <el-checkbox label="relation_type_name">操作类型</el-checkbox>
                    <el-checkbox label="store_name">仓库</el-checkbox>
                    <el-checkbox label="status">库存变化</el-checkbox>
                    <el-checkbox label="buying_price">进货单价</el-checkbox>
                    <el-checkbox label="buying_price_total">进货价合计</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="cm_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="cm_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                store_list: [],
                goods_type_list: [],
                cm_list_form: {
                    start_date: '',
                    end_date: '',
                    shop_id: '',
                    store_id: '',
                    store_disabled: false,
                    goods_type: '',
                    status: '',
                    mobile: '',
                    relation_type: ''
				},
				cm_list: [],
				cm_list_page: 1,
                cm_list_total: 0,
                cm_export_sign: false,
				cm_export_all: false,
                cm_export_ids: [],
                cm_export_list: ['time', 'relation_id', 'shop_name', 'mobile', 'goods_type_name', 'goods_name', 'goods_unit_name', 'quantity', 'relation_type_name', 'store_name', 'status', 'buying_price', 'buying_price_total'],
                cm_export_type: '1',
                cm_quantity_total: '',
                cm_buying_price_total: '',
            }
        },
        mounted: function() {
            // 日期
            this.cm_list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.cm_list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.cm_list_form.shop_id = this.shop_list[0].id;
                this.getStore(this.shop_list[0].id);
                this.getGoodsType();
                this.getCmList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.cm_list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.cm_list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.cm_list_form.start_date = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.cm_list_form.end_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.cm_list_date).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.cm_list_form.start_date = start.format('YYYY-MM-DD HH:mm');
                    _this.cm_list_form.end_date = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        _this.setShopDefaultTime(_this.shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 仓库数据
            getStore: function(shop_id) {
                const _this = this;

                if(shop_id == '') {
                    _this.cm_list_form.store_id = '';
                    _this.cm_list_form.store_disabled = true;
                } else {
                    _this.cm_list_form.store_id = '';
                    _this.cm_list_form.store_disabled = false;
                    _this.setShopDefaultTime(shop_id);
                    Vue.axios.post('PublicData/api_getStoreList', {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "shop_id": shop_id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            _this.store_list = res.data.response.result;
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                }
            },
            // 商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },



            getCmList(page) {
				const _this = this;

                _this.loading = true;
				Vue.axios.post('FinanceReport/getConfiscateDetailList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.cm_list_form.start_date,
                            "end_date": _this.cm_list_form.end_date,
                            "shop_id": _this.cm_list_form.shop_id,
                            "store_id": _this.cm_list_form.store_id,
                            "goods_type": _this.cm_list_form.goods_type,
                            "status": _this.cm_list_form.status,
                            "mobile": _this.cm_list_form.mobile,
                            "relation_type": _this.cm_list_form.relation_type
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.cm_list_total = Number(res.data.response.result.count);
							_this.cm_quantity_total = res.data.response.result.quantity_total;
							_this.cm_buying_price_total = res.data.response.result.buying_price_total;
						}
						_this.cm_list = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			cmQuery() {
				this.getCmList(1);
            },
            // 导出
            cmExportAll(val) {
				this.cm_export_ids = val ? this.cm_export_list : [];
				this.cm_export_sign = false;
			},
			cmExportChange(val) {
				const len = val.length;
				this.cm_export_all = len === this.cm_export_list.length;
				this.cm_export_sign = len > 0 && len < this.cm_export_list.length;
			},
            cmExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "FinanceReport/detailCommonExport?bill_type=confiscate"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.cm_export_ids = res.data.response.result.export_fields;
                            _this.cm_export_type = res.data.response.result.export_type;
                        } else {
                            _this.cm_export_ids = _this.cm_export_list;
                            _this.cm_export_type = '1';
                        }
                        _this.cmExportChange(_this.cm_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.cm_list_export)
                }, function() {
                    _this.cmExport();
                });
            },
            cmExport: function() {
                window.location.href = Vue.ctUrl + "FinanceReport/detailCommonExport?bill_type=confiscate" +
                    "&start_date=" + this.cm_list_form.start_date +
                    "&end_date=" + this.cm_list_form.end_date +
                    "&shop_id=" + this.cm_list_form.shop_id +
                    "&store_id=" + this.cm_list_form.store_id +
                    "&goods_type=" + this.cm_list_form.goods_type +
                    "&status=" + this.cm_list_form.status +
                    "&mobile=" + this.cm_list_form.mobile +
                    "&relation_type=" + this.cm_list_form.relation_type +
                    "&export_fields=" + JSON.stringify(this.cm_export_ids) +
                    "&export_type=" + this.cm_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>